import React from "react";
import { Link } from "react-router-dom";
import { FaUser, FaUserPlus } from "react-icons/fa";
import getImageUrl from "../../utils/imageUtils";
import { useSuggestedUsers } from "../../hooks/useSuggestedUsers";
import styles from "../../styles/components/feed/SuggestedUsersPanel.module.css";

const SUGGESTED_USERS_LIMIT = 4;

const SuggestedUsersPanel = () => {
  const {
    data: suggestedUsers = [],
    isLoading: loading,
    isError,
    refetch,
    isRefetching,
  } = useSuggestedUsers({
    limit: SUGGESTED_USERS_LIMIT,
  });

  return (
    <div className={styles.panel}>
      <h3 className={styles.title}>
        <FaUserPlus aria-hidden="true" /> Suggested people
      </h3>

      {loading ? (
        <div className={styles.skeletonList}>
          <div className={styles.skeletonRow} />
          <div className={styles.skeletonRow} />
          <div className={styles.skeletonRow} />
        </div>
      ) : isError ? (
        <div className={styles.empty} role="alert">
          <p>Couldn't load suggestions right now.</p>
          <button
            type="button"
            className={styles.ctaSecondary}
            onClick={() => refetch()}
            disabled={isRefetching}
          >
            {isRefetching ? "Retrying…" : "Try again"}
          </button>
        </div>
      ) : suggestedUsers.length > 0 ? (
        <>
          <div className={styles.userList}>
            {suggestedUsers.slice(0, SUGGESTED_USERS_LIMIT).map((user) => (
              <Link
                key={user._id}
                to={`/user/${user._id}`}
                className={styles.userRow}
                title={user.username ? `@${user.username}` : undefined}
              >
                <div className={styles.avatar}>
                  {user.avatar ? (
                    <img
                      src={getImageUrl(user.avatar)}
                      alt=""
                      className={styles.avatarImage}
                    />
                  ) : (
                    <FaUser aria-hidden="true" />
                  )}
                </div>
                <div className={styles.details}>
                  <span className={styles.username}>@{user.username}</span>
                  <span className={styles.bio}>
                    {user.followerCount ?? user.followers?.length ?? 0} followers
                  </span>
                </div>
              </Link>
            ))}
          </div>
          <Link to="/users/search" className={styles.seeAll}>
            <span className={styles.seeAllPrimary}>Connect with people</span>
          </Link>
        </>
      ) : (
        <div className={styles.empty}>
          <p>Discover people who share your product interests.</p>
          <Link to="/users/search" className={styles.ctaSecondary}>
            Connect with people
          </Link>
        </div>
      )}
    </div>
  );
};

export default React.memo(SuggestedUsersPanel);
